import React, { FC } from 'react';
import { Avatar, Box, Chip, CircularProgress, Tooltip, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { CaseListSourceStatus, CaseListStatus, ScanSource } from 'models/scanner-case';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import SyncProblemIcon from '@mui/icons-material/SyncProblem';
import SyncLockIcon from '@mui/icons-material/SyncLock';

type StatusIndicatorProps = {
    source: ScanSource;
    status: CaseListStatus;
};
const StatusIndicator: FC<StatusIndicatorProps> = ({ source, status }: StatusIndicatorProps) => {
    const { t: translate } = useTranslation(['scan-cases']);

    const getAvatar = () => {
        switch (status.status) {
            case CaseListSourceStatus.IN_SYNC:
                return (
                    <Avatar sx={{ bgcolor: '#f2f2f2' }}>
                        <CheckCircleOutlineIcon color="success" />
                    </Avatar>
                );
            case CaseListSourceStatus.NOT_AUTHENTICATED:
                return (
                    <Avatar sx={{ bgcolor: '#f2f2f2' }}>
                        <SyncLockIcon color="warning" />
                    </Avatar>
                );
            case CaseListSourceStatus.ERROR:
                return (
                    <Avatar sx={{ bgcolor: '#f2f2f2' }}>
                        <SyncProblemIcon color="error" />
                    </Avatar>
                );
            case CaseListSourceStatus.PERFORMING_SYNC:
                return (
                    <Avatar sx={{ bgcolor: '#f2f2f2' }}>
                        <CircularProgress size="18px" />
                    </Avatar>
                );
        }
    };

    const handleClick = () => {
        if (status.status === CaseListSourceStatus.NOT_AUTHENTICATED) {
            window.location.reload();
        }
    };

    return (
        <Box>
            <Tooltip title={translate(`scan-cases:STATUS_${status.status}`)}>
                <Chip
                    avatar={getAvatar()}
                    label={translate(`scan-cases:${source}`)}
                    clickable={status.status === CaseListSourceStatus.NOT_AUTHENTICATED}
                    onClick={handleClick}
                />
            </Tooltip>
        </Box>
    );
};

export default StatusIndicator;
